// extracted by mini-css-extract-plugin
module.exports = {"dyWorkbenchGroupInterval":"dy-workbench-group-interval___AGccj"};